// @ts-nocheck
import React from 'react';
import { Layer } from 'react-map-gl/mapbox';

import { MAP_STYLE_CODE_FONT } from '../helpers';

type Props = {
  id: string;
  source: string;
  styleCode: string;
};

const IconLayer: React.VFC<Props> = ({ id, source, styleCode }) => {
  const fontFamily = MAP_STYLE_CODE_FONT[styleCode] || MAP_STYLE_CODE_FONT.default;
  return (
    <Layer
      filter={['==', ['get', 'iconStyleCode'], styleCode]}
      id={`layer_${id}_icon_${styleCode}`}
      key={`layer_${id}_icon_${styleCode}`}
      layout={{
        'icon-optional': true,
        'text-allow-overlap': true,
        'text-anchor': 'center',
        'text-field': ['get', 'icon'],
        'text-font': [fontFamily],
        'text-line-height': 0,
        'text-offset': [0, 0.15],
        'text-padding': 0,
        'text-size': ['interpolate', ['linear'], ['zoom'], 10, 0, 12, 4, 13, 8, 14, 10, 15, 12, 16, 14]
      }}
      paint={{
        'text-color': '#FFFFFF',
        'text-translate-anchor': 'viewport'
      }}
      source={source}
      type="symbol"
    />
  );
};

export default IconLayer;
